import { ClinicPatientType, userType } from "../../DTO";
import { Api } from "../api";
import { extractClinicPatient } from "./shared";

export const ShowClinicPatient = (user: userType, id: number) => {
    return new Promise<{ patient: ClinicPatientType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: `clinic/patients/${id}`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) =>
                resolve({
                    patient: extractClinicPatient(data?.data ?? data),
                }),
            )
            .catch((err: any) => reject(err));
    });
};
